var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-icon",attrs:{"variant":"gradient-danger","size":"sm"},on:{"click":function($event){return _vm.$emit('exclude')}}},[_c('feather-icon',{attrs:{"icon":"MinusIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }